import type { SVGProps } from 'react';
export const Link = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="m11.48 5-1.41 1.4a.68.68 0 1 1-.96-.95l1.43-1.42.02-.03a3.85 3.85 0 0 1 5.41 5.47l-2.03 2.02a3.83 3.83 0 0 1-5.43 0 .68.68 0 1 1 .96-.95 2.5 2.5 0 0 0 3.51 0L15 8.51A2.5 2.5 0 0 0 11.48 5m-2.7 3.73a2.5 2.5 0 0 0-1.76.73L5 11.49A2.5 2.5 0 0 0 8.52 15l1.41-1.4a.68.68 0 1 1 .96.95l-1.43 1.42-.02.03a3.85 3.85 0 0 1-5.41-5.47l2.03-2.02a3.83 3.83 0 0 1 5.43 0 .68.68 0 0 1-.96.95 2.5 2.5 0 0 0-1.75-.73"
      clipRule="evenodd"
    />
  </svg>
);
